// extracted by mini-css-extract-plugin
export default {"wrapper":"HeadlineSection_wrapper__5t+dk"};